// extracted by mini-css-extract-plugin
module.exports = {"icon":"Item_icon__3cl9F"};